import {
  Component,
  OnDestroy,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { DAAS, MY_PROFILE, PROFILE } from 'src/app/shared/routeLink.constant';
import { AuthenticationService } from 'src/app/shared/service/authentication.service';
import { CommonService } from 'src/app/shared/service/common.service';
import { selectUser } from 'src/app/store/user/user.selectors';
import { UniversalFilterHelperService } from 'src/app/shared/component/filter/universal-filter/universal-filter-helper.service';
import { COMMON_SVG_IMG_PATH } from 'src/app/shared/common.constant';
import { Subject, Subscription, filter, startWith, takeUntil } from 'rxjs';
import { AlertSseService } from 'src/app/core/services/alert-sse.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Output() toggleSidenav = new EventEmitter<void>();

  userProfile: any;
  isOptionShow = false;
  titleName = '';
  svgPath: string = COMMON_SVG_IMG_PATH;
  visible = false;
  showRedDot = false;
  hasNewNotification = false;
  private sub?: Subscription;
  showLogoutFlag = true;
  showUniversalFilter = true;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly commonService: CommonService,
    private readonly _AuthenticationService: AuthenticationService,
    private readonly router: Router,
    private readonly store: Store,
    private readonly universalFilterHelperService: UniversalFilterHelperService,
    private readonly alertSseService: AlertSseService
  ) {}

  ngOnInit(): void {
    const impersonate = localStorage.getItem('impersonate') === 'true';
    this.showLogoutFlag = !impersonate;
    this.getUserProfile();
    this.sub = this.alertSseService.alerts$.subscribe((event) => {
      if (event === true || event?.newAlert === true) {
        if (!this.visible) {
          this.showRedDot = true;
          this.hasNewNotification = true;
        }
      }
    });
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        startWith(null),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        const url = this.router.url;
        // Insights and the DAAS pages (/daas/...) have their own filters
        const daasUrl = `/${DAAS}`;
        const isDaasPage =
          url === daasUrl ||
          ['/', '?', '#'].some((next) => url.startsWith(daasUrl + next));
        this.showUniversalFilter = !url.startsWith('/Insight') && !isDaasPage;
      });
  }

  logout() {
    this.universalFilterHelperService.resetCache();
    this._AuthenticationService.logoutFromHead();
    localStorage.clear();
  }

  getUserProfile() {
    this.store.select(selectUser).subscribe((user) => {
      this.titleName = user?.name ?? '';
    });
  }

  toggle() {
    this.isOptionShow = !this.isOptionShow;
  }

  navigateProfile() {
    this.toggle();
    this.router.navigateByUrl(`/${PROFILE}/${MY_PROFILE}`);
  }

  toggleNotification() {
    this.visible = true;
    this.showRedDot = false;
    setTimeout(() => {
      this.hasNewNotification = false;
    }, 100);
  }

  onNotificationDrawerClose() {
    this.hasNewNotification = false;
  }

  onNotificationsViewed() {
    this.showRedDot = false;
    this.hasNewNotification = false;
  }

  openAira() {
    const url = environment.airaUrl;
    const accessToken = this.commonService.getAccessToken();
    const refreshToken = this.commonService.getRefreshToken();
    const fullUrl = `${url}?access_token=${accessToken}&refresh_token=${refreshToken}`;
    window.open(fullUrl, '_blank');
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.sub?.unsubscribe();
  }
}
